export const MaxLength = 120;
export const errors = {
  required: "Це поле обов'язкове",
  maxlength: `Максимальна довжина ${MaxLength} символів`,
  patternDescription: 'Введено недоступні символи',
};
